<script lang="ts">
  import { onMount } from "svelte"
  import { slide } from "svelte/transition"
  import { ChevronLeft, ChevronRight } from "lucide-svelte"
  import { xhr } from "$app/utils"

  let props = $props()
  let { questions } = props
  let response = $state(props.response)

  //console.log(questions)
  //console.log(response)

  let number_of_questions: number = $derived(Object.entries(questions).length)
  let current_question = $derived(questions[response.current_step])
  let current_step: number = $derived(response.current_step)
  let current_answer = $derived(
    response.response_answers.find((a) => a.step == current_step)
  )

  let selected_answer = $state(null)

  let progress = $derived(() => {
    if (current_step < number_of_questions) {
      return Math.round(((current_step - 1) / number_of_questions) * 100)
    } else if (current_step == number_of_questions) {
      return 100
    }
  })

  function shuffle(array) {
    let i = array.length,
      j,
      temp

    while (--i > 0) {
      j = Math.floor(Math.random() * (i + 1))
      temp = array[j]
      array[j] = array[i]
      array[i] = temp
    }
    return array
  }

  onMount(() => {
    selected_answer = current_answer?.answer
  })

  function previous() {
    if (current_step > 1) {
      current_step--
      response.current_step = current_step
      current_question = questions[response.current_step]
      current_answer = response.response_answers.find(
        (a) => a.step == current_step
      )
      selected_answer = current_answer?.answer
      console.log("Current Answer: ", current_answer)
    }
  }

  async function submitResponse(): Promise<void> {
    try {
      const resp = await xhr.patch(`/responses/${response.id}.json`, {
        response_answer: {
          step: response.current_step,
          answer: selected_answer
        }
      })

      selected_answer = null
      response = resp.data

      current_question = questions[response.current_step]
      current_answer = response.response_answers.find(
        (a) => a.step == current_step
      )
      selected_answer = current_answer?.answer
      console.log("Current Answer: ", current_answer)
    } catch (e: any) {
      console.log(e)
      //toast("There was an error saving your responsetification", "error")
    }
  }

  let name: string = $state("")
  let email: string = $state("")
  async function viewResults(): Promise<void> {
    if (name.length == 0) {
      alert("Please enter your full name")
      return
    }
    if (email.length == 0) {
      alert("Please enter a valid email address")
      return
    }

    try {
      const resp = await xhr.patch(`/quiz/${response.id}.json`, {
        response: {
          email: email,
          name: name
        }
      })

      response = resp.data

      if (response.completed_at && response.email) {
        window.location.href = `/results/${response.access_key}`
      }
    } catch (e: any) {
      console.log(e)
      //toast("There was an error saving your responsetification", "error")
    }
  }
</script>

<div class="bg-gray-900 px-4 py-8 sm:py-16 lg:px-8">
  <div class="mx-auto max-w-2xl text-center">
    <h2 class="text-4xl font-semibold tracking-tight text-white sm:text-7xl">
      Readiness Quiz
    </h2>
    <p
      class="mt-2 sm:mt-8 text-sm font-medium text-pretty text-gray-400 sm:text-xl/8"
    >
      Based on real moments. Answer with radical honesty.
    </p>
  </div>

  <div class="max-w-5xl mx-auto mt-6 sm:mt-12">
    <div class="mt-6" aria-hidden="true">
      <div class="overflow-hidden rounded-full bg-gray-200">
        <div
          class="h-3 rounded-full bg-green-500"
          style="width: {progress()}%"
        ></div>
      </div>
    </div>
  </div>
</div>
{#if response.completed_at}
  <div class="bg-white sm:py-8">
    <div class="mx-auto max-w-7xl sm:px-6 lg:px-8">
      <div
        class="relative isolate overflow-hidden bg-blue-900 px-6 py-12 sm:py-18 shadow-xl sm:rounded-xl sm:px-12 xl:py-24"
      >
        <h2
          class="mx-auto max-w-3xl text-center text-2xl font-semibold tracking-tight text-white sm:text-5xl"
        >
          Your Readiness Score Awaits
        </h2>
        <p
          class="mx-auto mt-6 max-w-xl text-center text-base sm:text-lg text-gray-300"
        >
          Congratulations on completing the Readiness Quiz. To view your results
          please enter your name and email address to view the online report and
          download an offline PDF report.
        </p>
        <form
          class="mx-auto mt-10 flex max-w-xl gap-x-4"
          method="post"
          onsubmit={(e) => {
            e.preventDefault()
            viewResults()
          }}
        >
          <label for="name" class="sr-only">Name</label>
          <input
            id="name"
            type="type"
            name="name"
            bind:value={name}
            required
            placeholder="Your full name"
            class="min-w-0 flex-auto rounded-md bg-white/5 px-3.5 py-2 text-base text-white outline-1 -outline-offset-1 outline-white/10 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-white sm:text-sm/6"
          />
          <label for="email-address" class="sr-only">Email address</label>
          <input
            id="email-address"
            type="email"
            name="email"
            bind:value={email}
            required
            placeholder="Your email"
            autocomplete="email"
            class="min-w-0 flex-auto rounded-md bg-white/5 px-3.5 py-2 text-base text-white outline-1 -outline-offset-1 outline-white/10 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-white sm:text-sm/6"
          />
          <button
            type="submit"
            class="flex-none rounded-md bg-white px-3.5 py-2.5 text-sm font-semibold text-gray-900 shadow-xs hover:bg-gray-100 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
            >View Results</button
          >
        </form>
        <svg
          viewBox="0 0 1024 1024"
          aria-hidden="true"
          class="absolute top-1/2 left-1/2 -z-10 size-256 -translate-x-1/2"
        >
          <circle
            r="512"
            cx="512"
            cy="512"
            fill="url(#759c1415-0410-454c-8f7c-9a820de03641)"
            fill-opacity="0.7"
          />
          <defs>
            <radialGradient
              id="759c1415-0410-454c-8f7c-9a820de03641"
              r="1"
              cx="0"
              cy="0"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(512 512) rotate(90) scale(512)"
            >
              <stop stop-color="#7775D6" />
              <stop offset="1" stop-color="#E935C1" stop-opacity="0" />
            </radialGradient>
          </defs>
        </svg>
      </div>
    </div>
  </div>
{:else}
  <div class="px-6 lg:px-8 xl:px-0 py-6 sm:py-12 mx-auto max-w-6xl">
    {#each Object.entries(questions) as [step, question] (step)}
      {#if parseInt(step) === current_step}
        <div transition:slide>
          <p class="text-lg font-bold">
            Question {current_step} of {number_of_questions}
          </p>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-x-16 mt-4 sm:mt-8">
            <div>
              <p class="text-lg sm:text-2xl">
                {question.question}
              </p>
            </div>
            <div class="mt-5 sm:mt-0">
              <div class="space-y-1">
                {#each shuffle(Object.entries(question.answers)) as [id, answer]}
                  <div
                    class="flex items-center py-2 px-2"
                    class:bg-blue-50={selected_answer == id}
                  >
                    <div class="size-6 flex items-center">
                      <input
                        id="answer_{id}"
                        onclick={() => {
                          selected_answer = id
                        }}
                        checked={selected_answer == id}
                        value={id}
                        name="question_{response.current_step}"
                        type="radio"
                        class="relative size-5 appearance-none rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full before:bg-white not-checked:before:hidden checked:border-indigo-600 checked:bg-indigo-600 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:border-gray-300 disabled:bg-gray-100 disabled:before:bg-gray-400 forced-colors:appearance-auto forced-colors:before:hidden"
                      />
                    </div>
                    <label
                      for="answer_{id}"
                      class="ml-3 block text-base sm:text-xl/6 text-gray-900"
                      class:font-bold={selected_answer == id}>{answer}</label
                    >
                  </div>
                {/each}
              </div>
            </div>
          </div>
        </div>
      {/if}
    {/each}
    <div class="flex items-center justify-center mt-6 sm:mt-16 gap-x-3">
      {#if response.current_step > 1}
        <button
          type="button"
          onclick={previous}
          class="inline-flex items-center gap-x-2 rounded-sm bg-indigo-600 px-4 py-3 text-lg font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-amber-600"
        >
          <ChevronLeft class="size-6" />

          Previous
        </button>
      {/if}

      {#if response.current_step == number_of_questions}
        <button
          type="button"
          onclick={submitResponse}
          disabled={!selected_answer}
          class="inline-flex items-center gap-x-2 rounded-sm bg-green-600 px-6 py-3 text-xl font-bold text-white shadow-xs hover:bg-green-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600 disabled:text-gray-300 disabled:bg-gray-400"
        >
          FINISH
        </button>
      {:else}
        <button
          type="button"
          disabled={!selected_answer}
          onclick={submitResponse}
          class="inline-flex items-center gap-x-2 rounded-sm bg-indigo-600 px-4 py-3 text-lg font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:text-gray-300 disabled:bg-gray-400"
        >
          Next
          <ChevronRight class="size-6" />
        </button>
      {/if}
    </div>
  </div>
{/if}
